// The fixed fees a fee earner can ask Accounts to add on an invoice request.
//
// Vanessa, 29 Sep 2026: replaces the old TT fee and digital onboarding fee
// (both shown as £35 + VAT), worded exactly as she gave them. The backend
// copy is backend/hub/invoice_request_fees.py, and
// backend/tests/test_invoice_request_fee_lines.py fails if the two disagree.
//
// The two TT lines put Faster Payment against "> 250,000" and CHAPS against
// "< 250,000", as given; that has been asked back to Vanessa. If it is the
// other way round, swap the two labels here and in the backend table.
export const INVOICE_REQUEST_FEES = [
  { field: "onboarding_fee_count", label: "Onboarding Fee", amount: "25.00", unit: "per person" },
  { field: "aml_check_fee_count", label: "ID/AML Check (Thirdfort)", amount: "35.00", unit: "per person" },
  { field: "faster_payment_fee_count", label: "TT Fees > 250,000 / Faster Payment Fee", amount: "12.50", unit: "per transaction" },
  { field: "chaps_fee_count", label: "TT Fees < 250,000 / CHAPS Fee", amount: "12.50", unit: "per transaction" },
];

export const FEE_COUNT_OPTIONS = ["0", "1", "2", "3", "4", "5"];

// "£25.00 plus VAT per person"
export const feeRate = (fee) => `£${fee.amount} plus VAT ${fee.unit}`;

// Submissions made before 29 Sep 2026 carry these two fields instead; they
// are shown at the wording they were requested under, not repriced.
export const LEGACY_INVOICE_REQUEST_FEES = [
  { field: "tt_fee_count", label: "TT Fees (old form)", rate: "£35 + VAT each" },
  { field: "ob_fee_count", label: "Digital Onboarding (old form)", rate: "" },
];
